import { z } from 'zod';
import { IntakeItemDocument } from './intakeItemDocument';
import { providerSchema } from './provider';
import { claimSchema } from './claim';
import { siteSchema } from './site';
export const intakeItemSchema = z.object({
  id: z.guid(),
  siteID: z.guid(),
  providerID: z.guid(),
  createdAt: z.coerce.date(),
  completedAt: z.coerce.date().optional().nullable(),
  status: z.string(),
  notes: z.string().optional().nullable(),
  assigneeUserID: z.guid().optional().nullable(),
  intakeNumber: z.number(),
});

export const createIntakeItemInputSchema = intakeItemSchema.omit({
  intakeNumber: true,
});

export const updateIntakeItemSchema = intakeItemSchema.partial();

export type IntakeItem = z.infer<typeof intakeItemSchema> & {
  provider: z.infer<typeof providerSchema> | null;
  claims: z.infer<typeof claimSchema>[] | null;
  site: z.infer<typeof siteSchema> | null;
  documents: IntakeItemDocument[] | null;
};
export type CreateIntakeItemInput = z.infer<typeof createIntakeItemInputSchema>;
export type UpdateIntakeItemInput = z.infer<typeof updateIntakeItemSchema>;

export const isIntakeItem = (
  obj: any
): obj is z.infer<typeof intakeItemSchema> => {
  return intakeItemSchema.safeParse(obj).success;
};
